import { Component,  OnInit, ViewEncapsulation, ViewContainerRef } from '@angular/core';
import { MenuItems } from '../shared/components/menu-items/menu-items';
import { animate, AUTO_STYLE, state, style, transition, trigger } from '@angular/animations';
import { LoginProvider } from "../shared/providers/login.provider";
import { LocalStorage } from "../shared/wrappers/LocalStorage";
import { Router } from "@angular/router";
import { UserProvider } from "../shared/providers/user.provider";
import { ToastsManager } from 'ng2-toastr/ng2-toastr';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: [
        trigger('slideInOut', [
            state('shw-rside', style({
                transform: 'translate3d(0, 0, 0)'
            })),
            state('off', style({
                transform: 'translate3d(100%, 0, 0)'
            })),
            transition('shw-rside => off', animate('400ms ease-in-out')),
            transition('off => shw-rside', animate('400ms ease-in-out'))
        ]),
        trigger('toggledMenu', [
            state('out, void',
                style({
                    overflow: 'hidden',
                    height: '0px',
                })
            ),
            state('in',
                style({
                    overflow: 'hidden',
                    height: AUTO_STYLE,
                })
            ),
            transition('out <=> in', [
                animate('400ms ease-in-out')
            ])
        ]), trigger('toggledSubMenu', [
            state('off, void',
                style({
                    overflow: 'hidden',
                    height: '0px',
                })
            ),
            state('on',
                style({
                    overflow: 'hidden',
                    height: AUTO_STYLE,
                })
            ),
            transition('off <=> on', [
                animate('400ms ease-in-out')
            ])
        ])
    ]
})
export class AppComponent implements OnInit {
    currentUser:any;
    menuType: string;
    menuItemsArray:any;
    headerType: string;
    sidebarType: string;
    themeType: string;
    toggledArrow: string;
    selected: any;
    selectedSub: any;
    windowHeight: number;
    windowWidth: number;
    settingToggle: string;
    logged = false;

    constructor(public menuItems: MenuItems,
        public userProvider: UserProvider,
        private loginProvider: LoginProvider,
        private localStorage: LocalStorage,
        private router: Router,
        public toastr: ToastsManager,
        vcr: ViewContainerRef) {

        this.toastr.setRootViewContainerRef(vcr);


        this.themeType = 'default';
        this.toggledArrow = 'icon-arrow-left-circle';
        this.settingToggle = 'off';
        this.windowHeight = window.innerHeight - 60;
        this.windowWidth = window.innerWidth;
        if (this.windowWidth < 1400) {
            this.menuType = 'mini-sidebar';
        }
        if (this.windowWidth < 768) {
            this.toggledArrow = 'fa fa-bars';
        }

        this.loginProvider.logInObserver().subscribe(() => {
            this.logged = true;
        });

        this.logged = this.loginProvider.isLoggedIn();


    }

    async ngOnInit() {
        this.menuItemsArray = this.menuItems.getAll();
        this.currentUser = this.localStorage.retrieve("user");
        this.menuItemsArray[0].main.map(item=>{
            if(item.name == "Notificações" && this.currentUser){
                item.state = `${this.currentUser.username}`
            }
        });
    }

    onResize(event) {
        this.windowHeight = event.target.innerHeight - 60;
        this.windowWidth = window.innerWidth;
        if (this.windowWidth < 1170) {
            this.menuType = 'mini-sidebar';
        } else {
            this.menuType = '';
        }

        if (this.windowHeight < 768) {
            this.toggledArrow = this.menuType === 'mini-sidebar show-sidebar' ? 'fa fa-close' : 'fa fa-bars';
        } else {
            this.toggledArrow = this.menuType === 'mini-sidebar' ? 'fa fa-bars' : 'icon-arrow-left-circle';
        }
    }

    onToggled() {
        if (this.windowWidth < 768) {
            this.selectedSub = 0;
            this.selected = 0;
            this.menuType = this.menuType === 'mini-sidebar show-sidebar' ? 'mini-sidebar' : 'mini-sidebar show-sidebar';
            this.toggledArrow = this.menuType === 'mini-sidebar show-sidebar' ? 'fa fa-close' : 'fa fa-bars';
        } else {
            this.selectedSub = 0;
            this.selected = 0;
            this.toggledArrow = this.menuType === 'mini-sidebar' ? 'icon-arrow-left-circle' : 'fa fa-bars';
            this.menuType = this.menuType === 'mini-sidebar' ? '' : 'mini-sidebar';
        }
    }


    select(item) {
        this.selectedSub = 0;
        this.selected = (item !== this.selected) ? item : 0;
    }

    selectSub(item, main_item) {
        this.selectedSub = (item !== this.selectedSub) ? item : 0;
        this.selected = main_item;
    }

    logout() {
        this.localStorage.persist('user', null);
        this.localStorage.persist('approval', null);
        this.localStorage.persist('billing-filters', null);
        this.logged = false;
        this.router.navigateByUrl('login');
    }

}






// WEBPACK FOOTER //
// ./src/app/views/app.component.ts